import { gql } from '@apollo/client';
export const ANNOUNCEMENT_FIELDS = gql`
  fragment Announcement on AnnouncementDTO {
    subject
    announcementID
    body
    startDate
    endDate
    readDate
    isRead
    sendBy
    id
  }
`;